import { Box } from '@factorialco/deprecated-design-system'
import {
  BankingOnboardingFragment,
  LegalEntityForSelectFragment,
} from 'generated/resources/graphql'

import { AccountOnboardingCard } from 'modules/banking/components/AccountOnboardingCard'
import { getDefaultAlias, mapStatusToText } from 'modules/banking/utils'

interface OnboardingCardsProps {
  onboardings: BankingOnboardingFragment[]
  search: string
  selectedLegalEntity?: LegalEntityForSelectFragment
}

export const AccountOnboardingCardList = ({
  onboardings,
  search,
  selectedLegalEntity,
}: OnboardingCardsProps) => {
  const onboardingMatchesSearch = (onboarding: BankingOnboardingFragment) => {
    const searchText = search.toUpperCase()
    return (
      getDefaultAlias(onboarding.creationSource).toUpperCase().includes(searchText) ||
      mapStatusToText(onboarding.status).toUpperCase().includes(searchText) ||
      (onboarding.legalEntity.legalName || '').toUpperCase().includes(searchText)
    )
  }

  const filteredOnboardings = onboardings
    .filter((el) => (!selectedLegalEntity ? true : el.legalEntity.id == selectedLegalEntity.id))
    .filter((el) => el.status !== 'completed')
    .filter((el) => onboardingMatchesSearch(el))

  return (
    <>
      {filteredOnboardings.map((onboarding) => {
        return (
          <Box key={'onboarding_' + onboarding.id}>
            <AccountOnboardingCard onboarding={onboarding} />
          </Box>
        )
      })}
    </>
  )
}
